import {ethers} from "ethers";

let provider
let signer

function getEthProviderAndSigner(){
    if (!window.ethereum) {
        throw Error("Eth wallet not detected")
    }

    if (!provider){
        provider = new ethers.providers.Web3Provider(window.ethereum)
    }

    if (!signer) {
        signer = provider.getSigner()
    }

    return {provider, signer}
}

export default {
    getEthProviderAndSigner
}